module.exports = __webpack_public_path__ + "public/images/icons/palm.d6873a084710dff6d435738957e80997.png";